/**
 * Include your custom JavaScript here.
 *
 * We also offer some hooks so you can plug your own logic. For instance, if you want to be notified when the variant
 * changes on product page, you can attach a listener to the document:
 *
 * document.addEventListener('variant:changed', function(event) {
 *   var variant = event.detail.variant; // Gives you access to the whole variant details
 * });
 *
 * You can also add a listener whenever a product is added to the cart:
 *
 * document.addEventListener('product:added', function(event) {
 *   var variant = event.detail.variant; // Get the variant that was added
 *   var quantity = event.detail.quantity; // Get the quantity that was added
 * });
 */

// Add search icon to top left corner
document.addEventListener('DOMContentLoaded', function() {
  // Create a style element for custom CSS
  var style = document.createElement('style');
  
  // Add CSS for the search icon
  style.innerHTML = `
    .LeftSearch {
      position: absolute;
      top: 18px;
      left: 20px;
      z-index: 10;
      cursor: pointer;
      transition: color 0.2s ease-in-out;
    }
    
    .LeftSearch svg {
      width: 18px;
      height: 18px;
    }
    
    /* Match header color scheme */
    .Header--transparent .LeftSearch {
      color: #ffffff;
    }
    
    .Header--transparent .LeftSearch svg {
      filter: drop-shadow(0 1px rgba(0,0,0,0.25));
    }
    
    .Header--transparent.is-hovered .LeftSearch,
    .Header:not(.Header--transparent) .LeftSearch {
      color: #000000;
    }
    
    .Header--transparent.is-hovered .LeftSearch svg {
      filter: none;
    }
    
     @media screen and (max-width: 1240px) {
      .LeftSearch {
        display: none;
      }
    }
    
      
      .LeftSearch svg {
        width: 16px;
        height: 16px;
      }
    }
  `;
  
  // Append the style to head
  document.head.appendChild(style);
  
  // Create the search icon element
  var searchIcon = document.createElement('div');
  searchIcon.className = 'LeftSearch';
  searchIcon.setAttribute('aria-controls', 'Search');
  searchIcon.setAttribute('data-action', 'open-modal');
  
  // Create SVG for the search icon
  searchIcon.innerHTML = `
    <svg class="Icon Icon--search" role="presentation" viewBox="0 0 18 17">
      <g transform="translate(1 1)" stroke="currentColor" fill="none" fill-rule="evenodd" stroke-linecap="square">
        <path d="M16 16l-5.0752-5.0752"></path>
        <circle cx="6.4" cy="6.4" r="6.4"></circle>
      </g>
    </svg>
  `;
  
  // Add the search icon to the header
  var header = document.querySelector('.Header');
  if (header) {
    header.appendChild(searchIcon);
    
    // Add hover listener to match header behavior
    header.addEventListener('mouseenter', function() {
      if (header.classList.contains('Header--transparent')) {
        header.classList.add('is-hovered');
      }
    });
    
    header.addEventListener('mouseleave', function() {
      header.classList.remove('is-hovered');
    });
    
    // Handle scroll to match header transparency behavior
    if (header.classList.contains('Header--transparent')) {
      window.addEventListener('scroll', function() {
        if (window.pageYOffset <= 10) {
          header.classList.add('Header--transparent');
          header.classList.remove('is-scrolled');
        } else {
          header.classList.remove('Header--transparent');
          header.classList.add('is-scrolled');
        }
      });
    }
  }
});

// Fix for Shopify app embeds display issue
document.addEventListener('DOMContentLoaded', function() {
  // Make sure app blocks are visible
  const appBlocks = document.querySelectorAll('.shopify-app-block');
  if (appBlocks.length > 0) {
    appBlocks.forEach(block => {
      block.style.display = 'block';
      block.style.visibility = 'visible';
      block.style.opacity = '1';
    });
  }
  
  // Force refresh app embeds
  const refreshAppEmbeds = function() {
    if (window.Shopify && window.Shopify.loadFeatures) {
      window.Shopify.loadFeatures([
        {
          name: 'shopify-xr',
          version: '1.0',
          onLoad: () => {
            console.log('App features loaded successfully');
          }
        }
      ]);
    }
    
    // Check for app blocks again after a delay
    setTimeout(() => {
      const appBlocksAfterDelay = document.querySelectorAll('.shopify-app-block, [data-shopify-editor-block]');
      if (appBlocksAfterDelay.length > 0) {
        appBlocksAfterDelay.forEach(block => {
          block.style.display = 'block';
          block.style.visibility = 'visible';
          block.style.opacity = '1';
        });
      }
    }, 2000);
  };
  
  // Run immediately and again after page is fully loaded
  refreshAppEmbeds();
  window.addEventListener('load', refreshAppEmbeds);
});

// Adjust slideshow height to be 100vh minus marquee height
document.addEventListener('DOMContentLoaded', function() {
  function adjustSlideshowHeight() {
    const marquee = document.querySelector('.marquee-container');
    const slideshow = document.querySelector('.Slideshow--fullscreen');
    
    if (marquee && slideshow) {
      const marqueeHeight = marquee.offsetHeight;
      const windowHeight = window.innerHeight;
      const newHeight = windowHeight - marqueeHeight;
      
      // Apply the height to the slideshow
      slideshow.style.height = newHeight + 'px';
      
      // Also adjust any slideshow image containers to maintain aspect ratio
      const imageContainers = slideshow.querySelectorAll('.Slideshow__ImageContainer');
      imageContainers.forEach(container => {
        container.style.height = newHeight + 'px';
      });
      
      // Update Flickity if it's initialized
      const flickityInstance = Flickity.data(slideshow.querySelector('.Slideshow__Carousel'));
      if (flickityInstance) {
        flickityInstance.resize();
      }
    }
  }
  
  // Run on page load
  adjustSlideshowHeight();
  
  // Run on window resize
  window.addEventListener('resize', adjustSlideshowHeight);
  
  // Run after images load to ensure correct calculations
  window.addEventListener('load', adjustSlideshowHeight);
});

// Enable product image hover effect on mobile devices
document.addEventListener('DOMContentLoaded', function() {
  // Add custom CSS to make alternate images visible on mobile
  const style = document.createElement('style');
  style.innerHTML = `
    @media (-moz-touch-enabled: 1), (hover: none) {
      .ProductItem__Image--alternate {
        display: block !important; /* Override the display: none from theme */
        opacity: 0 !important;
        transition: opacity 0.3s ease-in-out;
      }
      
      .ProductItem__ImageWrapper--withAlternateImage.show-alternate .ProductItem__Image {
        opacity: 0 !important;
      }
      
      .ProductItem__ImageWrapper--withAlternateImage.show-alternate .ProductItem__Image--alternate {
        opacity: 1 !important;
      }
      
      /* Remove the overlay indicator since tapping will now directly open the product */
      .ProductItem__ImageWrapper--withAlternateImage::after {
        display: none;
      }
    }
  `;
  document.head.appendChild(style);
  
  // Function to handle image swipe
  function handleImageSwipe(event) {
    // Only for touch devices
    if (window.matchMedia('(-moz-touch-enabled: 1), (hover: none)').matches) {
      event.preventDefault(); // Prevent scrolling during swipe
      
      // Add class to show alternate image
      this.classList.add('show-alternate');
      
      // Set a timeout to remove the class after swipe is done
      clearTimeout(this.swipeTimeout);
      this.swipeTimeout = setTimeout(() => {
        this.classList.remove('show-alternate');
      }, 1500); // Remove after 1.5 seconds of no swipe activity
    }
  }
  
  // Function to setup product image hover
  function setupProductImageHover() {
    const productImageWrappers = document.querySelectorAll('.ProductItem__ImageWrapper--withAlternateImage');
    
    productImageWrappers.forEach(wrapper => {
      // Remove existing event listeners to prevent duplicates
      wrapper.removeEventListener('touchmove', handleImageSwipe);
      
      // Add touchmove event listener for swipe/slide behavior
      wrapper.addEventListener('touchmove', handleImageSwipe, { passive: false });
      
      // For touchstart/touchend, we don't need to add handlers
      // as the default link behavior will work for taps/clicks
      
      // Add a class to indicate this has been initialized
      wrapper.classList.add('mobile-hover-enabled');
    });
  }
  
  // Initial setup
  setupProductImageHover();
  
  // Re-run setup after page changes (for ajax-loaded content)
  document.addEventListener('shopify:section:load', setupProductImageHover);
  document.addEventListener('shopify:section:unload', setupProductImageHover);
  
  // Also check for any dynamically loaded products
  const observer = new MutationObserver(function(mutations) {
    mutations.forEach(function(mutation) {
      if (mutation.addedNodes.length > 0) {
        setupProductImageHover();
      }
    });
  });
  
  // Start observing the document body for changes
  observer.observe(document.body, { childList: true, subtree: true });
  
  // Also run the setup when scrolling stops to catch any newly loaded items
  let scrollTimeout;
  window.addEventListener('scroll', function() {
    clearTimeout(scrollTimeout);
    scrollTimeout = setTimeout(function() {
      setupProductImageHover();
    }, 200);
  }, { passive: true });
});